<template>
  <div>
  <b-form-input
    style="margin-bottom: 10px; margin-top: 20px; width: 300px"
    id="filter-input"
    v-if="showSearch"
    v-model="searchTerm"
    type="search"
    :placeholder="$t('label_administration_searchTerm')"
  ></b-form-input>
  <div style="max-height: 600px; overflow-y: scroll">
    <b-container>
      <b-row>
        <b-col cols="12">
          <template v-if="showTableOptions">
            <b-checkbox
              v-for="(data, index) in getLocalFilteredOptions(allDataArray)"
              :key="index"
              v-model="data.selected"
              @change.native="change()"
            >
              {{ data.name }}
            </b-checkbox>
          </template>
          <b-checkbox
            v-for="(data, index) in otherOptionsCloned"
            :key="index"
            v-model="data.selected"
            @change.native="change()"
          >
            {{ data.name }}
          </b-checkbox>
        </b-col>
      </b-row>
    </b-container>
  </div>
  </div>
</template>
<script>
import { axiosCall } from "../axiosCall";
import { cloneDeep } from "lodash";

export default {
  name: "IndicaCheckBox",
  props: {
    tableName: {
      type: String,
      default: null,
    },
    saveToStore: {
      type: Boolean,
      default: false,
    },
    showTableOptions: {
      type: Boolean,
      default: true,
    },
    showSearch: {
      type: Boolean,
      default: false,
    },
    storeName: {
      type: String,
      default: null,
    },
    storeIndex: {
      type: Number,
      default: -1,
    },
    otherOptions: {
      type: Array,
      default: () => [],
    },
    filterByField: {
      type: String,
      default: null,
    },
    filterByValue: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      allDataArray: [],
      otherOptionsCloned: [],
      searchTerm:''
    };
  },
  watch: {
    storeIndex: function () {
      this.getStoreData();
    },
    saveToStore: function () {
      this.getStoreData();
    },
    otherOptions: {
      handler: function () {
        this.otherOptionsCloned = cloneDeep(this.otherOptions);
      },
      deep: true,
    },
  },
  created() {
    this.refreshData();
    this.getStoreData();
  },
  mounted() {
    if (this.otherOptions) {
      this.otherOptionsCloned = cloneDeep(this.otherOptions);
    }
  },
  methods: {
    clearStorageAndRefresh(){
      if(this.saveToStore){
        const payload = {};
        payload["data"] = {};
        payload["storeName"] = this.storeName;
        payload["storeIndex"] = this.storeIndex;
        payload["data"]["selected"] = [];
        this.$store.dispatch("setStoreInfo", payload);
        this.$emit("change-selection");
      }
      this.refreshData()
    },
    getLocalFilteredOptions(array){
      return array.filter((elem)=>elem.name.toLowerCase().includes(this.searchTerm.toLowerCase())).sort((a,b)=> a.name.localeCompare(b.name))
    },
    change() {
      const payload = {};
      payload["data"] = {};
      payload["storeName"] = this.storeName;
      payload["storeIndex"] = this.storeIndex;
      payload["data"]["selected"] = [
        ...this.allDataArray.filter((data) => data.selected),
        ...this.otherOptionsCloned.filter((data) => data.selected),
      ];
      this.$store.dispatch("setStoreInfo", payload);
      this.$emit("change-selection");
    },
    refreshData: async function () {
      await this.getMany(this.tableName);
    },
    getStoreData() {
      if (this.saveToStore === true && this.storeName) {
        const _ = require("lodash");
        let storeInfo = _.cloneDeep(
          this.$store.getters.getStoreInfo(this.storeName)
        );
        if (storeInfo) {
          if (this.storeIndex !== -1) {
            storeInfo = storeInfo[this.storeIndex];
          }
        }
        if (storeInfo) {
          if (storeInfo && storeInfo.selected) {
            storeInfo.selected.map((preVal) => {
              if (preVal.selected) {
                this.allDataArray.map((data) => {
                  if (data.id === preVal.id) {
                    data.selected = true;
                  }
                });
              }
            });
          }
        }
      }
    },
    getMany: async function (table) {
      const where = { where: {} };
      if (this.filterByField && this.filterByValue) {
        where["where"][this.filterByField] = this.filterByValue;
      }
      await axiosCall({
        url: `${table}?filter=${JSON.stringify(where)}`,
        method: "get",
      }).then((response) => {
        this.allDataArray = response.data;
        this.getStoreData();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
